import React, { Component } from "react";
import TranscriptList from "./Content";
import connectToScroller from "../connectToScroller";

class TranscriptTextView extends Component {
  constructor(props) {
    super(props);
    this._scrollRef = React.createRef();
  }

  componentDidMount() {
    this.updateScrollHeight();
  }

  componentDidUpdate(nextProps) {
    this.updateScrollHeight(nextProps);
  }

  setScrollRef = (element) => {
    this._scrollRef = element;
  };

  updateScrollHeight(pProps) {
    const props = pProps || this.props;
    if (this._scrollRef) {
      if (props.setScrollRef) {
        props.setScrollRef(this._scrollRef); // a lot of knockabout with scroll ref?
      }
    }
  }

  render() {
    return (
      <article ref={this.setScrollRef.bind(this)} className="transcript-data">
        <TranscriptList {...this.props} />
      </article>
    );
  }
}

export default connectToScroller(TranscriptTextView);
